import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  fetchPrimaryDoctorAsync,
  handleLoadingState,
  savePrimaryDoctorAsync,
  primaryDoctorSelector,
} from '../../../lib/dataLayer';
import { isLoadingSelector } from '../../../store/app/selectors';
import PrimaryDoctorPage from '../components/PrimaryDoctorPage';

const mapStateToProps = state => ({
  primaryDoctor: primaryDoctorSelector(state),
  isLoading: isLoadingSelector(state),
});

const mapDispatchToProps = {
  onMount: () => handleLoadingState(fetchPrimaryDoctorAsync),
  onSave: savePrimaryDoctorAsync,
  onContinue: () => push('/specialists'),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrimaryDoctorPage);



// WEBPACK FOOTER //
// ./src/modules/PrimaryDoctorPage/containers/PrimaryDoctorPageContainer.js